import homeRoutes from './homeRoutes'
import financeRoutes from './financeRoutes'
import errorRoutes from './errorRoutes'
import LoginRoutes from './LoginRoutes'
import certificationRoutes from './certificationRoutes'
import userProtocolRoutes from './userProtocolRoutes'
import mallRoutes from './mallRoutes'
export const routes = [
  ...homeRoutes,
  ...LoginRoutes,
  ...mallRoutes,
  ...certificationRoutes,
  userProtocolRoutes,
  financeRoutes,
  ...errorRoutes,
  { path: '*', redirect: '/404' }
]